import React, {createContext, ReactNode, useContext, useMemo} from 'react';

interface NavigationContextType {
    navigate: (segment: string) => void;
}

const NavigationContext = createContext<NavigationContextType | null>(null);

interface NavigationProviderProps {
    navigate: (path: string) => void;
    children: ReactNode;
}

export const NavigationProvider = ({navigate, children}: NavigationProviderProps) => {
    const value = useMemo<NavigationContextType>(() => ({
        navigate: (segment: string) => navigate(`/${segment}`),
    }), [navigate]);

    return (
        <NavigationContext.Provider value={value}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useAppNavigation = (): NavigationContextType => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useAppNavigation must be used within a NavigationProvider');
    }
    return context;
};
